import { isExpEditor } from '../lib/lib'
import 'jquery-ui'

class blockAccordion {
  constructor(element) {
    if (!element) {
      return false
    }

    if (isExpEditor()) {
      return false
    }

    this.acc = jQuery(element)

    this.acc.accordion({
      active: false,
      collapsible: true,
      heightStyle: 'content',
    })
  }
}
export default blockAccordion
